import serpApi from '@/app/Serp/api/serpApi';
import type {
  SerpDataResponse,
  SerpIdRequest
} from '@/app/Serp/types/serpApiTypes';

const getSerpDataApi = serpApi.injectEndpoints({
  endpoints: build => ({
    getSerpData: build.query<SerpDataResponse, SerpIdRequest>({
      query: body => ({
        url: `/serp/v2/serp_data_by_id`,
        method: 'POST',
        body
      }),
      providesTags: ['SerpOverview']
    })
  })
});

export const { useGetSerpDataQuery } = getSerpDataApi;

export default getSerpDataApi;
